var __jsx = React.createElement;
import React from "react";
import loadingAnimation from "../../../assets/animations/loading-page.json";
import loadingResultsExplore from "../../../assets/animations/loading-results-explore.json";
import loadingResultsFunbank from "../../../assets/animations/loading-results-funbank.json";
import loadingResultsShopstar from "../../../assets/animations/loading-results-shopstar.json";
import loadingResultsA from "../../../assets/animations/loading-results-a.json";
import MuscleLoattieAnimation from "./templates/lottie-animation";
import loadingAnimationB from "../../../assets/animations/loading-animation-b.json";
import APP_CONFIGURATION from "@lib/app.config";
const LoadingAnimation = _ref => {
  var _APP_CONFIGURATION$co;
  let {
    height = 100,
    color = APP_CONFIGURATION.config.spinnerColor,
    text,
    loadingApp = false,
    canForceEntityLoader
  } = _ref;
  const app = (_APP_CONFIGURATION$co = APP_CONFIGURATION.config.appName) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : "Funbank";
  const loaders = {
    Explore: loadingResultsExplore,
    Funbank: loadingResultsFunbank,
    Shopstar: loadingResultsShopstar,
    "Banco General": loadingResultsA,
    "Benefit Viajes": loadingAnimationB
  };
  const getLoaderBasedOnApp = () => {
    if (canForceEntityLoader || loadingApp) {
      return loaders[app];
    } else {
      return loadingApp && canForceEntityLoader ? loaders[app] : loadingAnimation;
    }
  };
  const loader = getLoaderBasedOnApp();
  return __jsx("div", {
    className: "flex items-center justify-center"
  }, __jsx(MuscleLoattieAnimation, {
    lottieJson: loader,
    height: height,
    color: color,
    text: text,
    addEntityLogo: canForceEntityLoader
  }));
};
export default LoadingAnimation;